import { put, select, delay } from 'redux-saga/effects'
import importer from 'common/importer'
const LoyalDonorActions = importer('Stores/Loyalty/Actions')
const { tokens, user } = importer('Stores/Users/Select', null)

export default function* success({ res, donorSfid }) {
  try {
    const _tokens = yield select(tokens)
    const { token_type, id_token } = _tokens
    const token = `${token_type} ${id_token}`

    // Add a delay of 1.5 seconds
    yield delay(1200)

    yield put(LoyalDonorActions.getLoyaltyPromotions(donorSfid, token))
  } catch (error) {}
}
